import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { AiUpdateQuestionChangeStrategy } from '../../../../bases/ai-change-preview/strategies/update-question-ai-change.strategy';
import { AnswerItem } from '../components';
import styled from '@xstyled/styled-components';
import { getSize, styleVariables } from '@lib/common';
import { MathEnabledTextComponent } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledAnswerContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: ", ";\n"])), getSize('padding12'));
var StyledAnswerGroup = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  width: 100%;\n"])), getSize('padding12'));
var StyledAnswerDescription = styled(MathEnabledTextComponent)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  font-weight: 500;\n  color: #1e293b;\n  line-height: ", ";\n  p {\n    margin: 0;\n    display: inline;\n  }\n"])), getSize('typo16'), getSize('padding24'));
var StyledAnswerDescriptionBefore = styled(StyledAnswerDescription)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  text-decoration: line-through;\n  background-color: #fef2f2;\n  padding: 0 4px;\n  border-radius: 2px;\n  *,\n  span,\n  p {\n    text-decoration: line-through !important;\n    color: ", " !important;\n    display: inline;\n  }\n"])), styleVariables.colors.colorErrorBase, styleVariables.colors.colorErrorBase);
var StyledAnswerDescriptionAfter = styled(StyledAnswerDescription)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n  background-color: #f0fdf4;\n  padding: 0 4px;\n  border-radius: 2px;\n  *,\n  span,\n  p {\n    color: ", " !important;\n    display: inline;\n  }\n"])), styleVariables.colors.colorSuccessBase, styleVariables.colors.colorSuccessBase);
export var MultipleChoiceUpdateQuestionStrategy = /*#__PURE__*/function (_AiUpdateQuestionChan) {
  _inherits(MultipleChoiceUpdateQuestionStrategy, _AiUpdateQuestionChan);

  var _super = _createSuper(MultipleChoiceUpdateQuestionStrategy);

  function MultipleChoiceUpdateQuestionStrategy(context) {
    _classCallCheck(this, MultipleChoiceUpdateQuestionStrategy);

    return _super.call(this, context);
  }

  _createClass(MultipleChoiceUpdateQuestionStrategy, [{
    key: "renderAnswerDescription",
    value: function renderAnswerDescription(after, before) {
      var isDeleted = !(before !== null && before !== void 0 && before.description) && !after.description;

      if (isDeleted) {
        return /*#__PURE__*/_jsx(StyledAnswerDescriptionBefore, {
          value: after.description
        });
      }

      var isNew = !(before !== null && before !== void 0 && before.description) && after.description;

      if (isNew) {
        return /*#__PURE__*/_jsx(StyledAnswerDescriptionAfter, {
          value: after.description
        });
      }

      var isModified = (before === null || before === void 0 ? void 0 : before.description) && after.description && before.description !== after.description;

      if (isModified) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(StyledAnswerDescriptionBefore, {
            value: before.description
          }), /*#__PURE__*/_jsx(StyledAnswerDescriptionAfter, {
            value: after.description
          })]
        });
      }

      return /*#__PURE__*/_jsx(StyledAnswerDescriptionAfter, {
        value: after.description
      });
    }
  }, {
    key: "renderAnswers",
    value: function renderAnswers() {
      var _after$answers,
          _this = this;

      var before = this.context.before;
      var after = this.context.after;
      return /*#__PURE__*/_jsx(StyledAnswerContainer, {
        children: /*#__PURE__*/_jsx(StyledAnswerGroup, {
          children: after === null || after === void 0 ? void 0 : (_after$answers = after.answers) === null || _after$answers === void 0 ? void 0 : _after$answers.map(function (answer, index) {
            var _before$answers, _after$correctAnswers;

            var beforeAnswer = before === null || before === void 0 ? void 0 : (_before$answers = before.answers) === null || _before$answers === void 0 ? void 0 : _before$answers.find(function (a) {
              return a.id.toString() === answer.id.toString();
            });
            var isSelected = after === null || after === void 0 ? void 0 : (_after$correctAnswers = after.correctAnswers) === null || _after$correctAnswers === void 0 ? void 0 : _after$correctAnswers.some(function (ca) {
              return ca.answerId === answer.id.toString();
            });
            return /*#__PURE__*/_jsx(AnswerItem, {
              index: index,
              values: {
                description: _this.renderAnswerDescription(answer, beforeAnswer),
                isSelected: isSelected
              }
            }, answer.id.toString());
          })
        })
      });
    }
  }]);

  return MultipleChoiceUpdateQuestionStrategy;
}(AiUpdateQuestionChangeStrategy);